import React, { useEffect, useState } from "react";
import { TitleHeading } from "../../molecules/TitleHeading";
import { ArrowButton } from "../../molecules/ArrowButton";
import { DetailBox } from "../../molecules/DetailBox";
import { Carousel } from "primereact/carousel";
import { responsiveSliderOptions } from "../../assets/config";
import { useSelector, RootStateOrAny } from "react-redux";

const Slider1 = (props) => {
  const dashData = props.data;
  const { data, loading, error } = useSelector((state) => state?.clients);
  // console.log("clients123", data);

  const {
    data: clientsData,
    loading: loadingClients,
    error: errorCLients,
  } = useSelector((state) => state.blogs);

  // console.log(clientsData,"fff")
  const [sliderdata, setSliderdata] = useState([
    "media/home_slider/client_box.png",
    "media/home_slider/client_box-1.png",
    "media/home_slider/3_1.png",
    "media/home_slider/4_1.png",
    "media/home_slider/client_box.png",
    "media/home_slider/client_box-1.png",
    "media/home_slider/3_1.png",
  ]);
  useEffect(() => {
    if (clientsData && clientsData?.length > 0) {
      // Extracting images and setting sliderdata
      const logos = clientsData?.map((item) => item?.client_logo);
      setSliderdata(logos);
    }
  }, [clientsData]);
  // console.log(clientsData,"1121")

  const productTemplate = (item) => {
    if (!item || !item.client_logo) return null;

    return (
      <div className="text-center pb-0 px-3 pt-3">
        <img
          src={item?.client_logo}
          //alt={product.name}
          className="w-full"
        />
      </div>
    );
  };

  return (
    <div
      className="container mb-0 pl-0 pr-0  trustedContainer"
      style={{ marginTop: "0px" }}
    >
      <div className="grid section-title align-items-start">
        <div className="lg:col-6 md:col-6 sm:col-12 pl-0 pr-0">
          <div className="mb-1">
            <TitleHeading
              title={dashData?.trusted_globaly_title || "Trusted Globally"}
              className=""
            />
          </div>
          <div className="">
            <DetailBox
              details={
                dashData?.trusted_globaly_subtitle ||
                "by 300+ institutional investors & real-estate developers"
              }
            />
          </div>
        </div>
        <div
          className="md:col-6 sm:col-12 pr-0 flex align-items-center justify-content-end "
          style={{ marginTop: "0.9%" }}
        >
          <ArrowButton
            width="170"
            buttonText={dashData?.trusted_globaly_hyper_link_text || "Clients"}
            bgColor="#CDC08B"
            textColor="#000000"
            url={dashData?.trusted_globaly_hyper_link_link}
          />
        </div>
      </div>
      <div>
        <Carousel
          value={data || []} // Ensure 'data' is always an array
          numVisible={4}
          numScroll={1}
          responsiveOptions={responsiveSliderOptions}
          itemTemplate={productTemplate}
          showIndicators={false}
          showNavigators={false}
          autoplayInterval={3000}
          circular={false}
          style={{ backgroundColor: "transparent" }}
        />
      </div>
    </div>
  );
};

export default Slider1;
